import type { UserDto } from 'shared/dtos/users.dto';

export const enum UPDATE_PROFILE_STATUSES {
  IDLE = 'idle',
  PENDING = 'pending',
  FULFILLED = 'fulfilled',
  REJECTED = 'rejected',
}

export interface AuthenticationState {
  loggedIn: boolean;
  updateProfileStatus: UPDATE_PROFILE_STATUSES;
  user: UserDto | null;
}
